import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WidgetsService } from '../../shared/services/widgets.service';
import { requestNewsItemPayload } from '../../shared/models/model';
import { DomSanitizer } from '@angular/platform-browser';
import { FooterService } from '../../shared/services/footer.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-single-news',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './single-news.component.html',
  styleUrl: './single-news.component.scss',
})
export class SingleNewsComponent implements OnInit, OnDestroy {
  postName: string | null = '';
  newsItem: any;
  newsItemSubscription: Subscription = new Subscription();
  constructor(
    private _route: ActivatedRoute,
    private _widget: WidgetsService,
    private _location: Location,
    private _sanitizer: DomSanitizer,
    private _footerService: FooterService,
  ) {}

  ngOnInit(): void {
    this.postName = this._route.snapshot.paramMap.get('name'); // Stores News name.
    typeof this.postName === 'string' ? (this.postName = this.postName.replaceAll('-', ' ')) : (this.postName = '');

    const navigation = this._location.getState();
    const navState: any = navigation as { [key: string]: any };
    if (navState.obj) {
      this.getNewsItem(navState?.obj);
    }
  }
  getNewsItem(news_id: string) {
    const payload: requestNewsItemPayload = {
      requestingSystem: 'FinPro',
      id: news_id,
    };
    this.newsItemSubscription = this._widget.getNewsItem(payload)?.subscribe((_data) => {
      if (_data) {
        document.title = _data.shortTitle;
        this.newsItem = _data;
        this.setFooterDiscl_compl_Id(_data?.disclosureText, _data?.complainceID);
      }
    });
  }
  setFooterDiscl_compl_Id(disclosureText: string, complianceId: string) {
    if (disclosureText && disclosureText !== '') {
      this._footerService.setDisclosureText(disclosureText);
    }
    if (complianceId && complianceId !== '') {
      this._footerService.setComplianceID(complianceId);
    }
  }
  // Method to sanitize HTML content
  contentSanitizedHtml(_str: string) {
    const _str_refined = this.removeNewlines(_str);
    return this._sanitizer.bypassSecurityTrustHtml(_str_refined);
  }
  // Method to remove newlines
  removeNewlines(_str: string): string {
    return _str?.replace(/\n/g, ''); // Replaces all newline characters
  }
  ngOnDestroy(): void {
    this.newsItemSubscription.unsubscribe();
  }
}
